export default class PlotConfig {
  constructor(strSpec) {
    let pieces = strSpec.trim().split(/\s+/)
    this.pgn = pieces[0]
    this.indexes = pieces.slice(1)

    if (this.indexes.length % 2 != 0) this.indexes.push('64')

    this.ranges = []
    for (let i = 0; i < this.indexes.length; i += 2) {
      let start = parseInt(this.indexes[i])
      let end = parseInt(this.indexes[i + 1])
      this.ranges.push([start, end])
    }

    this.id = this.toString('_')
    this.isPinned = false
  }

  toString(sep = ' ') {
    let pieces = [this.pgn]
    for (let index of this.indexes)
      pieces.push(index.toString().padStart(2, '0'))
    return pieces.join(sep)
  }

  getValue(hexValue) {
    // eslint-disable-next-line no-undef
    const big = BigInt(hexValue)
    let result = 0n

    for (let i = 0; i < this.ranges.length; i++) {
      // 00 00 00 01   => start=3 end=6 => mask = 00 11 10 00

      const start = this.ranges[i][0]
      const end = this.ranges[i][1]
      // eslint-disable-next-line no-undef
      const len = BigInt(end - start)

      // eslint-disable-next-line no-undef
      const mask = ~(~0n << len) << BigInt(64 - end)

      // eslint-disable-next-line no-undef
      const part = (big & mask) >> BigInt(64 - end)

      result = result << len
      result = result | part

      // console.log(
      //   'range %s %s %s %s\n%s\n%s\n%s\n%s',
      //   this.ranges[i],
      //   start,
      //   end,
      //   len,
      //   big.toString(2).padStart(64, '0'),
      //   mask.toString(2).padStart(64, '0'),
      //   part.toString(2).padStart(64, '0'),
      //   result.toString(2).padStart(64, '0')
      // )
    }

    // eslint-disable-next-line no-undef
    return Number(result)
  }

  getter(dataPoint) {
    if ( dataPoint == null ) return null
    const key = this.pgn
    const lapse = dataPoint.lapse
    if (lapse != null && lapse[key] != null) {
      return lapse[key]
    } else {
      const sample = dataPoint.sample
      const variable = sample && sample.find((x) => x.code == key)
      const value = variable && this.getValue(variable.bigValue)
      if (value == null) return null
      return value
    }
  }
}
